import { COUNTRY_CODES } from "../constants";
import { useTrunkGatewayContext } from "@/react/features/support-tools/siptrunk/TrunkGatewayContext";
import LabeledSelect from "@/react/components/LabeledSelect";

export const TrunkGatewayCountrySelect = () => {
  const { state: trunkGateway, updateField } = useTrunkGatewayContext();

  return (
    <LabeledSelect
      prompt={"*Service Country"}
      options={COUNTRY_CODES}
      value={COUNTRY_CODES.find(
        (countryCode) =>
          countryCode.value === trunkGateway?.subscriberDetails?.serviceCountry
      )}
      onSelectionChanged={(opt) =>
        updateField("subscriberDetails.serviceCountry", opt)
      }
    />
  );
};
